module.exports = __webpack_public_path__ + "static/media/richard.3d27219e.jpg";